import { render } from "./StudioAgreementManager.vue?vue&type=template&id=87281c24"
import script from "./StudioAgreementManager.vue?vue&type=script&lang=js"
export * from "./StudioAgreementManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__